import {
  ACCOUNT_FEATURE,
  selectUserAccountRole,
  selectUserId,
  selectUserRolePermissions,
  USER_ROLE,
} from '@socialive/common';
import { selectFeature } from '@socialive/features';
import moment from 'moment';
import PropTypes from 'prop-types';
import { Component } from 'react';
import Modal from 'react-modal';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactTooltip from 'react-tooltip';
import roundRecordingDuration from '~/helpers/roundRecordingDuration';
import { selectIsDownloadsEnabled } from '~/store';
import { DEFAULT_STREAM_DESCRIPTION } from '../helpers/constants';
import decodeURIComponentSafe from '../helpers/decodeURIComponentSafe';
import { Pathnames, RecordingSource, StreamCheckmarkType } from '../helpers/enums';
import get from '../helpers/get';
import {
  broadcastStreamShape,
  heroStreamShape,
  routerHistoryShape,
  routerLocationShape,
  routerMatchShape,
} from '../helpers/propTypeShapes';
import '../style/herostream.css';
import ClipRecording from './ClipRecording';
import ConfirmationModal from './ConfirmationModal';
import DownloadButtonPicker from './DownloadButton/DownloadButtonPicker';
import ShareButton from './ShareButton';

const customClippingStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    maxWidth: '600px',
    padding: '0',
    textAlign: 'left',
    transform: 'translate(-50%, -50%)',
  },
  overlay: {
    backgroundColor: 'rgb(0,0,0,0.5)',
  },
};

const customStyles = {
  content: {
    top: '125px',
    left: 'auto',
    right: '15px',
    width: '228px',
    height: '112px',
    padding: '17px',
  },
  overlay: {
    backgroundColor: 'rgb(0,0,0,0)',
  },
};

class HeroStream extends Component {
  constructor(props) {
    super(props);

    const broadcastDescription = decodeURIComponentSafe(
      get(this.props.heroStream, 'broadcast.description', DEFAULT_STREAM_DESCRIPTION)
    );

    const broadcastTitle = decodeURIComponentSafe(
      get(this.props.heroStream, 'broadcast.name', '') || get(this.props.heroStream, 'title', '')
    );

    this.state = {
      seekFlag: false,
      heroStream: this.props.heroStream,
      clippingModalIsOpen: false,
      confirmationModalIsOpen: false,
      heroDeleteIsOpen: false,
      isCtrlKeyDown: false,
      optionsModalIsOpen: false,
      recordingToDelete: this.props.heroStream.id,
      displayCheckMark: StreamCheckmarkType.NONE,
      broadcastDescription,
      broadcastTitle,
      originalDescription: broadcastDescription,
      originalTitle: broadcastTitle,
    };

    this.closeModal = this.closeModal.bind(this);
    this.deleteBroadcast = this.deleteBroadcast.bind(this);
    this.deleteRecording = this.deleteRecording.bind(this);
    this.goBack = this.goBack.bind(this);
    this.handleClippingRequest = this.handleClippingRequest.bind(this);
    this.handleDescriptionChange = this.handleDescriptionChange.bind(this);
    this.handleTitleChange = this.handleTitleChange.bind(this);
    this.hideDeleteTooltip = this.hideDeleteTooltip.bind(this);
    this.openModal = this.openModal.bind(this);
    this.requestDeleteBroadcast = this.requestDeleteBroadcast.bind(this);
    this.requestDeleteRecording = this.requestDeleteRecording.bind(this);
    this.toggleEmptyClass = this.toggleEmptyClass.bind(this);
    this.onHandleDescriptionChange = this.onHandleDescriptionChange.bind(this);
    this.onHandleTitleChange = this.onHandleTitleChange.bind(this);
    this.handleVideoRightClick = this.handleVideoRightClick.bind(this);
  }

  componentDidMount() {
    const { videojs } = window;
    const playerElement = document.getElementsByClassName('video-js')[0];
    const title = document.getElementsByClassName('herostream-title')[0];
    const description = document.getElementsByClassName('hero-description')[0];

    videojs(playerElement, { controls: true });
    document.addEventListener('mousedown', this.handleClickHero, false);

    window.addEventListener('click', (event) => {
      const el = document.getElementById('deleteTooltip');

      if (el && !el.contains(event.target)) {
        this.hideDeleteTooltip();
      }
    });

    // Make video active (remove poster) when user initiates seek
    videojs(playerElement).on('seeking', () => {
      if (!this.state.seekFlag) {
        videojs(playerElement).play();
        setTimeout(() => {
          videojs(playerElement).pause();
        }, 100);

        this.setState({
          seekFlag: true,
        });
      }
    });

    document.addEventListener('keyup', (event) => {
      if (event.keyCode === 91) {
        this.setState({
          isCtrlKeyDown: false,
        });
      }
    });
    document.addEventListener('keydown', (event) => {
      if (event.keyCode === 91) {
        this.setState({
          isCtrlKeyDown: true,
        });
      }
    });
    description.addEventListener('keydown', (event) => {
      this.charLimiter(event);
    });
    description.addEventListener('paste', (event) => {
      this.pasteLimiter(event);
    });
    title.addEventListener('keydown', (event) => {
      this.charLimiter(event);
    });
    title.addEventListener('paste', (event) => {
      this.pasteLimiter(event);
    });
  }

  componentDidUpdate() {
    this.onBroadcastTitleUpdate();
  }

  componentWillUnmount() {
    const title = document.getElementsByClassName('herostream-title')[0];
    const description = document.getElementsByClassName('hero-description')[0];

    window.removeEventListener('click', (event) => {
      const el = document.getElementById('deleteTooltip');

      if (el && !el.contains(event.target)) {
        this.hideDeleteTooltip();
      }
    });

    document.removeEventListener('mousedown', this.handleClickHero, false);
    document.removeEventListener('keyup', (event) => {
      if (event.keyCode === 91) {
        this.setState({
          isCtrlKeyDown: false,
        });
      }
    });
    document.removeEventListener('keydown', (event) => {
      if (event.keyCode === 91) {
        this.setState({
          isCtrlKeyDown: true,
        });
      }
    });
    description.removeEventListener('keydown', (event) => {
      this.charLimiter(event);
    });
    description.removeEventListener('paste', (event) => {
      this.pasteLimiter(event);
    });
    title.removeEventListener('keydown', (event) => {
      this.charLimiter(event);
    });
    title.removeEventListener('paste', (event) => {
      this.pasteLimiter(event);
    });
  }

  handleClippingRequest() {
    this.openModal('clippingmodal');
  }

  handleVideoRightClick(event) {
    if (!this.props.isDownloadsEnabled) event?.preventDefault();
  }

  handleBroadcastInfoChange(params, target) {
    return fetch(`${this.props.APIBaseURL}/${target.dataset.broadcastsorstreams}/${target.dataset.broadcastid}`, params)
      .then((response) => {
        if (response.status === 401) {
          this.props.trackEvent('401', {
            source: 'HeroStream handleBroadcastInfoChange',
          });
          // eslint-disable-next-line no-console
          console.error('Received 401 response from handleBroadcastInfoChange (HeroStream). Redirecting to login.');
          this.props.reAuth(this.props.location.pathname, encodeURIComponent(this.props.location.search));
          return undefined;
        }
        if (response.status === 403) {
          const message = 'You do not have permission to make this change.';
          toast.error(message);
          throw new Error(message);
        }
        return response.json();
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error('Error: ', error);
        return { error: error.message };
      });
  }

  handleUpdateStreamDescription(params) {
    return fetch(`${this.props.APIBaseURL}/streams/${this.state.heroStream.id}`, params).then((response) => {
      if (response.status === 401) {
        this.props.trackEvent('401', {
          source: 'streams handleStreamInfoChange',
        });
        // eslint-disable-next-line no-console
        console.error('Received 401 response from handleStreamInfoChange (HeroStream). Redirecting to login.');
        this.props.reAuth(this.props.location.pathname, encodeURIComponent(this.props.location.search));
      }
    });
  }

  handleDescriptionChange(description, target) {
    const params = {
      method: 'PATCH',
      headers: {
        authorization: sessionStorage.getItem('authToken'),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        description,
      }),
    };

    this.handleUpdateStreamDescription(params);
    return this.handleBroadcastInfoChange(params, target);
  }

  handleEnterKey(event) {
    if (event.keyCode === 13) {
      event.preventDefault();
      event.target.blur();
    }
  }

  handleTitleChange(title, broadcastsOrStreams, target) {
    let nameOrTitle;

    if (broadcastsOrStreams === 'broadcasts') {
      nameOrTitle = JSON.stringify({
        name: title,
      });
    } else {
      nameOrTitle = JSON.stringify({
        title,
      });
    }
    const params = {
      method: 'PATCH',
      headers: {
        authorization: sessionStorage.getItem('authToken'),
        'Content-Type': 'application/json',
      },
      body: nameOrTitle,
    };

    return this.handleBroadcastInfoChange(params, target);
  }

  onBroadcastTitleUpdate() {
    const { broadcastTitle, originalTitle } = this.state;
    if (broadcastTitle === '' && originalTitle !== '') {
      this.setState({ broadcastTitle: originalTitle });
    }
  }

  async onHandleTitleChange(event) {
    const { broadcastTitle } = this.state;
    const { handleBroadcastTitleChange } = this.props;
    const { broadcast } = this.props;
    const broadcastsOrStreams = broadcast.isStream ? 'streams' : 'broadcasts';
    const newTitle = event.target.innerText.slice(0, 128);

    if (newTitle !== broadcastTitle && newTitle !== '') {
      const { error } = await this.handleTitleChange(newTitle, broadcastsOrStreams, event.target);
      if (error) {
        this.setState({ broadcastTitle: '' });
        return;
      }
      handleBroadcastTitleChange(newTitle);

      this.setState({ displayCheckMark: StreamCheckmarkType.TITLE });
      setTimeout(() => {
        this.setState({ displayCheckMark: StreamCheckmarkType.NONE });
      }, 2000);
    }

    this.setState({ broadcastTitle: newTitle });
  }

  async onHandleDescriptionChange(event) {
    const { broadcastDescription, originalDescription } = this.state;
    const description = event.target.innerText.substring(0, 1024);

    if (description !== broadcastDescription) {
      const { error } = await this.handleDescriptionChange(description, event.target);
      if (error) {
        this.setState({ broadcastDescription: originalDescription });
        return;
      }
      this.setState({ displayCheckMark: StreamCheckmarkType.DESCRIPTION });
      setTimeout(() => {
        this.setState({ displayCheckMark: StreamCheckmarkType.NONE });
      }, 2000);
    }

    const desc = description === '' ? originalDescription : description;
    this.setState({ broadcastDescription: desc });
  }

  pasteLimiter(passedEvent) {
    const { target } = passedEvent;
    const max = target.getAttribute('maxlength');

    setTimeout(() => {
      const trimmedText = target.innerText.substring(0, max);
      target.innerText = trimmedText;
    }, 100);
  }

  copyLinkToClipboard() {
    const el = document.getElementById('linkCopy');

    el.select();
    document.execCommand('copy');
  }

  openModal(modalName) {
    if (modalName === 'options') {
      this.setState({ optionsModalIsOpen: true });
    } else if (modalName === 'yousure') {
      this.setState({ optionsModalIsOpen: false });
      this.setState({ confirmationModalIsOpen: true });
    } else if (modalName === 'herodelete') {
      this.setState({ optionsModalIsOpen: false });
      this.setState({ heroDeleteIsOpen: true });
    } else if (modalName === 'clippingmodal') {
      this.setState({ optionsModalIsOpen: false });
      this.setState({ clippingModalIsOpen: true });
    }
  }

  closeModal() {
    this.setState({
      clippingModalIsOpen: false,
      heroDeleteIsOpen: false,
      confirmationModalIsOpen: false,
      optionsModalIsOpen: false,
    });
  }

  requestDeleteBroadcast() {
    this.openModal('yousure');
    this.hideDeleteTooltip();
  }

  deleteBroadcast() {
    const params = {
      method: 'delete',
      headers: {
        authorization: sessionStorage.getItem('authToken'),
        'Content-Type': 'application/json',
      },
    };

    fetch(`${this.props.APIBaseURL}/broadcast/delete/${this.props.match.params.id}`, params)
      .then((response) => {
        if (response.status === 401) {
          this.props.trackEvent('401', {
            source: 'deleteBroadcast (HeroStream)',
          });
          // eslint-disable-next-line no-console
          console.error('Received 401 response from deleteBroadcast (HeroStream). Redirecting to login.');
          this.props.reAuth(this.props.location.pathname, encodeURIComponent(this.props.location.search));
        } else {
          this.props.history.push(Pathnames.RECORDINGS);
        }
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error('delete broadcast API call failed. ', error);
      });
  }

  requestDeleteRecording() {
    this.openModal('herodelete');
    this.hideDeleteTooltip();
  }

  deleteRecording() {
    const params = {
      method: 'delete',
      headers: {
        authorization: sessionStorage.getItem('authToken'),
        'Content-Type': 'application/json',
      },
    };

    fetch(`${this.props.APIBaseURL}/stream/delete/${this.state.recordingToDelete}`, params)
      .then((response) => {
        if (response.status === 401) {
          this.props.trackEvent('401', {
            source: 'deleteRecording (HeroStream)',
          });
          // eslint-disable-next-line no-console
          console.error('Received 401 response from deleteRecording (HeroStream). Redirecting to login.');
          this.props.reAuth(this.props.location.pathname, encodeURIComponent(this.props.location.search));
        } else {
          this.props.reduceStreamCount();
          this.setState({ heroDeleteIsOpen: false });
          if (this.props.type === 'stream' || this.props.streamCount === 0) {
            this.props.history.push(Pathnames.RECORDINGS);
          } else {
            window.location.reload();
          }
        }
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error('stream/delete API call failed. ', error);
      });
  }

  goBack() {
    this.props.history.push(Pathnames.RECORDINGS);
  }

  charLimiter(passedEvent) {
    const { target } = passedEvent;
    const max = target.getAttribute('maxlength');

    if (target.innerText.length >= max && passedEvent.keyCode !== 8 && !this.state.isCtrlKeyDown) {
      passedEvent.preventDefault();
    }
  }

  hideDeleteTooltip() {
    document.getElementById('deleteTooltip').classList.remove('show');
    ReactTooltip.hide();
  }

  toggleEmptyClass(event) {
    const currentDescription = event.target.innerText;
    if (currentDescription === DEFAULT_STREAM_DESCRIPTION) {
      this.setState({ broadcastDescription: '' });
    }
  }

  render() {
    const { broadcastDescription, displayCheckMark, broadcastTitle } = this.state;
    const {
      broadcast,
      canClipVideo,
      canDeleteVideo,
      canEditOwnVideos,
      canEditOthersVideos,
      userId,
      userRole,
      isUserRolesEnabled,
    } = this.props;
    const stream = this.state.heroStream;
    const startedAt = moment(stream.startedAt).format('MMM Do YYYY, h:mm a');
    const videoElementId = `hero-stream-${stream.id}`;
    const sourceId = stream.id;
    const sourceDuration = roundRecordingDuration(stream.startedAt, stream.stoppedAt);
    const isBroadcastHost = stream.user.id === broadcast.user.id;
    const hostOrGuest = isBroadcastHost ? '(host)' : '(guest)';
    const title = stream?.title ? stream.title : `${stream.user.name} ${hostOrGuest}`;
    const sourcePoster = stream.thumbnail;
    const broadcastsOrStreams = broadcast.isStream ? 'streams' : 'broadcasts';

    let deleteBroadcast = '';

    const clipTooltipCopy = !isUserRolesEnabled || canClipVideo ? 'Clip' : 'No permission to clip';
    const deleteTooltipCopy = !isUserRolesEnabled || canClipVideo ? 'Delete' : 'No permission to delete';

    const isClippable = stream.outfile?.endsWith('mp4') ?? false;
    const isFormatM3u8 = !!stream.m3u8Url;
    const sourceURL = isFormatM3u8 ? stream.m3u8Url : stream.outfile;
    const sourceType = isFormatM3u8 ? 'application/x-mpegURL' : 'video/mp4';

    const deleteBroadcastEnabled = userRole === USER_ROLE.ADMIN || stream.broadcast?.user?.id === userId;
    const deleteRecordingEnabled = userRole === USER_ROLE.ADMIN || stream?.user?.id === userId;

    const allowContentEditing = isUserRolesEnabled
      ? canEditOthersVideos || (canEditOwnVideos && stream.user.id === userId)
      : deleteBroadcastEnabled || deleteRecordingEnabled;

    const isDeleteButtonEnabled = isUserRolesEnabled
      ? canDeleteVideo
      : deleteBroadcastEnabled || deleteRecordingEnabled;

    if (!broadcast.isStream) {
      deleteBroadcast = (
        <li
          className="broadcast-option delete"
          data-event={!isUserRolesEnabled || canDeleteVideo ? 'click focus' : ''}
          data-for="deleteTooltip"
          data-tip="Delete"
        >
          <button type="button" className="bin-icon" disabled={!isDeleteButtonEnabled} aria-label="Delete Recording" />
        </li>
      );
    } else {
      deleteBroadcast = (
        <li className="broadcast-option delete" data-for="herostream-tooltip" data-tip={deleteTooltipCopy}>
          <button
            type="button"
            className="bin-icon"
            disabled={!isDeleteButtonEnabled}
            onClick={this.requestDeleteRecording}
            aria-label="Delete Recording"
          />
        </li>
      );
    }

    return (
      <div className="herostream-content content-container">
        <div className="herostream-body">
          <div className="hero-player-container">
            <button type="button" className="hero-closer" onClick={this.goBack} aria-label="Close Broadcast" />
            <div className="hero-player">
              <video
                id={videoElementId}
                controls
                className="video-js"
                preload="metadata"
                onContextMenu={this.handleVideoRightClick}
              >
                <source src={sourceURL} type={sourceType} />
              </video>
            </div>
          </div>
          <div className="hero-copy">
            <div
              className="options-menu"
              ref={(parent) => {
                this.parent = parent;
              }}
            >
              <ul className="broadcast-options">
                <ShareButton videoId={stream.id} videoType="STREAM" duration={stream.durationSeconds} />

                {isClippable && (
                  <DownloadButtonPicker
                    type="herostream"
                    namingConvention={isBroadcastHost ? RecordingSource.HOST : RecordingSource.GUEST}
                    newTitle={this.props.newBroadcastTitle}
                    downloadFile={stream}
                  />
                )}

                {!isClippable && (
                  <li
                    className="broadcast-option download"
                    data-for="herostream-tooltip"
                    data-tip="This video recording cannot be downloaded"
                  >
                    <button type="button" disabled aria-label="Download" />
                  </li>
                )}

                {isClippable && (
                  <li className="broadcast-option clip" data-for="herostream-tooltip" data-tip={clipTooltipCopy}>
                    <button
                      disabled={!canClipVideo}
                      type="button"
                      onClick={this.handleClippingRequest}
                      data-recording-id={stream.id}
                      aria-label="Clip Recording"
                    />
                  </li>
                )}
                {deleteBroadcast}
              </ul>
              <ReactTooltip id="deleteTooltip" clickable effect="solid" place="bottom" type="light" border>
                {isDeleteButtonEnabled && deleteRecordingEnabled && (
                  <div>
                    <button type="button" className="delete-recording" onClick={this.requestDeleteRecording}>
                      Delete this recording
                    </button>
                  </div>
                )}
                {isDeleteButtonEnabled && deleteBroadcastEnabled && (
                  <div>
                    <button type="button" className="delete-broadcast" onClick={this.requestDeleteBroadcast}>
                      Delete entire broadcast
                    </button>
                  </div>
                )}

                {isUserRolesEnabled && !isDeleteButtonEnabled && <span>No permission to delete</span>}
              </ReactTooltip>
            </div>
            <div className="herostream-title-container">
              &#8203;
              <strong
                className="herostream-title"
                contentEditable={`${allowContentEditing}`}
                data-broadcastid={broadcast.id}
                data-broadcasttitle={broadcastTitle}
                data-broadcastsorstreams={broadcastsOrStreams}
                maxLength="1024"
                onBlur={this.onHandleTitleChange}
                onKeyDown={this.handleEnterKey}
                suppressContentEditableWarning
                title={broadcastTitle}
                role="textbox"
                tabIndex={0}
              >
                {broadcastTitle}
              </strong>
              {displayCheckMark === StreamCheckmarkType.TITLE && <span className="title-success-checkmark active" />}
              &#8203;
            </div>
            <div className="hero-host">{title}</div>
            <span className="byline">
              {stream.user.name} {hostOrGuest} - {startedAt} - {broadcast.remoteStream.name}
            </span>
            <br />
            &#8203;
            <span
              className="hero-description"
              contentEditable={`${allowContentEditing}`}
              data-broadcastdescription={broadcastDescription}
              data-broadcastid={broadcast.id}
              data-broadcastsorstreams={broadcastsOrStreams}
              maxLength="1024"
              onClick={this.toggleEmptyClass}
              onBlur={this.onHandleDescriptionChange}
              onKeyDown={this.handleEnterKey}
              suppressContentEditableWarning
              role="textbox"
              tabIndex={0}
            >
              {broadcastDescription}
            </span>
            {displayCheckMark === StreamCheckmarkType.DESCRIPTION && (
              <span className="description-success-checkmark active" />
            )}
            &#8203;
          </div>
        </div>
        <Modal isOpen={this.state.optionsModalIsOpen} onRequestClose={this.closeModal} style={customStyles}>
          <ul className="broadcast-options">
            <li className="broadcast-option back">
              <Link to="/dashboard">Back to Broadcasts</Link>
            </li>
            <li className="broadcast-option link">
              <button type="button" onClick={this.copyLinkToClipboard}>
                Copy link to broadcast
              </button>
            </li>
            <li className="broadcast-option delete">
              <button type="button" onClick={this.requestDeleteBroadcast}>
                Delete entire broadcast
              </button>
            </li>
          </ul>
        </Modal>

        <ConfirmationModal
          isOpen={this.state.confirmationModalIsOpen}
          handleOnClose={this.closeModal}
          handleOnConfirm={this.deleteBroadcast}
          resourceDescription="Do you really want to delete this entire broadcast? This cannot be undone."
        />

        <ConfirmationModal
          isOpen={this.state.heroDeleteIsOpen}
          handleOnClose={this.closeModal}
          handleOnConfirm={this.deleteRecording}
          resourceDescription="Do you really want to delete this recording? This cannot be undone."
        />

        <Modal isOpen={this.state.clippingModalIsOpen} onRequestClose={this.closeModal} style={customClippingStyles}>
          <ClipRecording
            APIBaseURL={this.props.APIBaseURL}
            broadcastTitle={this.props.broadcast.name}
            clipVidDuration={sourceDuration}
            clipVidPoster={sourcePoster}
            clipVidType={sourceType}
            clipVidURL={sourceURL}
            closeModal={this.closeModal}
            location={this.props.location}
            reAuth={this.props.reAuth}
            sourceId={sourceId}
            trackEvent={this.props.trackEvent}
          />
        </Modal>
        <ReactTooltip id="herostream-tooltip" effect="solid" type="light" border />

        <textarea id="linkCopy" className="" readOnly value={document.location} />
      </div>
    );
  }
}

HeroStream.propTypes = {
  APIBaseURL: PropTypes.string.isRequired,
  broadcast: broadcastStreamShape.isRequired,
  canClipVideo: PropTypes.bool.isRequired,
  canDeleteVideo: PropTypes.bool.isRequired,
  canEditOthersVideos: PropTypes.bool.isRequired,
  canEditOwnVideos: PropTypes.bool.isRequired,
  handleBroadcastTitleChange: PropTypes.func.isRequired,
  heroStream: heroStreamShape.isRequired,
  history: routerHistoryShape.isRequired,
  isDownloadsEnabled: PropTypes.bool.isRequired,
  isUserRolesEnabled: PropTypes.bool.isRequired,
  location: routerLocationShape.isRequired,
  match: routerMatchShape.isRequired,
  newBroadcastTitle: PropTypes.string.isRequired,
  reAuth: PropTypes.func.isRequired,
  reduceStreamCount: PropTypes.func.isRequired,
  streamCount: PropTypes.number.isRequired,
  trackEvent: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  userId: PropTypes.number.isRequired,
  userRole: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => {
  const { canClipVideo, canDeleteVideo, canEditOwnVideos, canEditOthersVideos } = selectUserRolePermissions(state);
  const [, { enabled: isUserRolesEnabled }] = selectFeature(ACCOUNT_FEATURE.USER_ROLES)(state);
  return {
    canClipVideo,
    canDeleteVideo,
    canEditOwnVideos,
    canEditOthersVideos,
    isUserRolesEnabled,
    userId: selectUserId(state),
    userRole: selectUserAccountRole(state),
    isDownloadsEnabled: selectIsDownloadsEnabled(state),
  };
};
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(HeroStream));
